module.exports = __webpack_public_path__ + "static/media/image7.610ea4bd.jpeg";